import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b8524736"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-body" }

import { ref, type Ref, computed, onMounted, onUnmounted, onUpdated } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLayout',
  setup(__props) {

const mainPadding = 30;

const header: Ref<HTMLElement | null> = ref(null);

const footer: Ref<HTMLElement | null> = ref(null);

const top = ref(0);

const bottom = ref(0);

const updateOffsets = (): void => {
  top.value = header.value?.offsetHeight ?? 0;
  bottom.value = footer.value?.offsetHeight ?? 0;
};

onMounted(() => {
  updateOffsets();
  window.addEventListener('resize', updateOffsets);
});

onUpdated(() => {
  updateOffsets();
});

onUnmounted(() => {
  window.removeEventListener('resize', updateOffsets);
});

const mainStyles = computed(() => {
  return {
    paddingTop: `${top.value + mainPadding}px`,
    paddingBottom: `${bottom.value + mainPadding}px`,
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "app-body__header",
      ref_key: "header",
      ref: header
    }, [
      _renderSlot(_ctx.$slots, "header")
    ], 512 /* NEED_PATCH */),
    _createElementVNode("main", {
      class: "app-main",
      style: _normalizeStyle(_unref(mainStyles))
    }, [
      _renderSlot(_ctx.$slots, "main")
    ], 4 /* STYLE */),
    _createElementVNode("div", {
      class: "app-body__footer",
      ref_key: "footer",
      ref: footer
    }, [
      _renderSlot(_ctx.$slots, "footer")
    ], 512 /* NEED_PATCH */)
  ]))
}
}

})